const swiper = new Swiper('#variant-addons .swiper', {
  slidesPerView: 'auto',
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const variant_addons_el = document.querySelectorAll('.variant-addons');
const variant_addons_container = document.getElementById('variant-addons--container');

document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
  let form = event.target; // The form that triggers the change

  let variant_id = variant.id;
  if(document.querySelector(`.variant-addons--${variant_id}`)) {
    var variantAddons = document.querySelector(`.variant-addons--${variant_id}`);
  console.log("variant_id",variant_id, variant_addons_el.length)
    variant_addons_el.forEach(variant_addon_el => {
      variant_addon_el.style.display = "none";
    });
    if(variantAddons.childNodes.length) {
      variant_addons_container.style.display = 'grid';
    } else {
      variant_addons_container.style.display = 'none';
    }
    document.querySelector(`.variant-addons--${variant_id}`).style.display = "block";
    document.querySelector(`.variant-addons--${variant_id}`).querySelector('.variant-addons--item input').checked = true
  }
});

const variant_addons = document.getElementById('variant-addons');
document.addEventListener('variant:add', function(event) {
  let items = event.detail.items; // Get items added
  let cart = event.detail.cart; // The whole cart content after the update

  console.log("cart,items",cart,items)
  var product_added = false;
  for(var i=0; i<items.length; i++) {
    if(items[i].product_id == variant_addons.dataset.productId) {
      product_added = true;
    }
  }

  if(product_added) {
    var variant_addon = variant_addons.querySelector('input[name="variant_addons"]:checked').value;
    var form_id = variant_addons.dataset.form;
    var qty_input = document.querySelector(`.quantity-selector__input[form="${form_id}"]`);
    var quantity = 1;
    if(qty_input) quantity = qty_input.value;
    console.log("quantity",qty_input)
    if(!variant_addon.includes('free')) {
      let formData = {
       'items': [{
        'id': variant_addon,
        'quantity': quantity
        }]
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }
});

